export const START_LIST_ID = 'product.list.start'
